import { render, staticRenderFns } from "./DynamicSearchesList.vue?vue&type=template&id=53758d02&scoped=true"
import script from "./DynamicSearchesList.vue?vue&type=script&lang=js"
export * from "./DynamicSearchesList.vue?vue&type=script&lang=js"
import style0 from "./DynamicSearchesList.vue?vue&type=style&index=0&id=53758d02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53758d02",
  null
  
)

export default component.exports